import React from 'react';
import Image from 'next/image';
import { CartHeaderProps } from 'types';

export function CartHeader(props: CartHeaderProps) {
  const image = props?.image;
  return (
    <div className="p-6 grid grid-cols-[1fr_2fr] gap-8">
      <div>
        <p className="text-black font-extrabold text-lg leading-[1.6] tracking-[0.02rem] m-0">{props.make}</p>
        <h2 className="text-black font-semibold text-[2rem] leading-[1.5] tracking-[0.02rem] m-0 p-0">
          {props.modelSeries}
        </h2>
        {props.showEquipmentListLink && (
          <a className="mt-[-1rem]" onClick={props?.onOpenEquipmentList}>
            <span className="text-black font-extrabold text-base pt-4">Vis komplett utstyrsliste</span>
          </a>
        )}
      </div>
      {!props.headerChildren && (
        <div className="max-h-[8.25rem]">
          {props?.showVehicleImage && (image?.defaultUrl || image?.url) && (
            <Image
              className="w-full object-contain max-h-[8.25rem]"
              src={image?.defaultUrl || image?.url}
              alt={image?.altText}
              width={100}
              height={100}
            />
          )}
        </div>
      )}
      {props?.headerChildren}
    </div>
  );
}
